module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__mask",
    class: _vm.classObject
  }), _c('div', {
    staticClass: "footer__left"
  }, [_c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: "#triggered",
        duration: 1250,
        easing: [0.445, 0.05, 0.55, 0.95],
        offset: -50,
        cancelable: true,
        x: false,
        y: true
      }),
      expression: "{ el: \"#triggered\", duration: 1250, easing: [0.445, 0.05, 0.55, 0.95], offset: -50, cancelable: true, x: false, y: true }"
    }],
    staticClass: "footer__button"
  }, [_c('Icon', {
    attrs: {
      "name": "arrow"
    }
  }), _vm._v("Back to top")], 1)]), _c('div', {
    staticClass: "footer__right"
  }, [_vm._v("Online Advantage by Rooster Grin Media")]), _c('div', {
    staticClass: "footer__container-userway-trigger",
    attrs: {
      "id": "accessibilityWidget",
      "tabindex": "0"
    }
  }, [_vm._v("Click for Accessibility")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-477e23e4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/Footer/Footer.pug
// module id = 594
// module chunks = 1